module.exports = __webpack_public_path__ + "img/pic_noting.39e90177.png";